import { isSameBoard } from "../boardNames";
import type {
  BoardCandidate,
  BoardPositionOrigin,
  BuildBoardCandidates,
  NamedPosition,
} from "./types";

const isKnown = (candidates: BoardCandidate[], name: string): boolean =>
  candidates.some(
    (candidate) =>
      isSameBoard({ board: name, name: candidate.name, label: candidate.name }) ||
      isSameBoard({ board: candidate.name, name, label: name }),
  );

export const buildBoardCandidates: BuildBoardCandidates = ({
  runSources,
  boardMarkers,
  viewBoards,
  boardText,
  annotationPixelsPerPdfPoint,
}) => {
  const candidates: BoardCandidate[] = Object.entries(runSources).map(
    ([name, position]) => ({
      name,
      position: { ...position },
      origin: "runSource",
      usedByRun: true,
    }),
  );

  const addUnused = (positions: NamedPosition[], origin: BoardPositionOrigin) => {
    positions.forEach(({ name, x, y }) => {
      const trimmed = name.trim();
      if (!trimmed || isKnown(candidates, trimmed)) return;
      candidates.push({
        name: trimmed,
        position: {
          x: x / annotationPixelsPerPdfPoint,
          y: y / annotationPixelsPerPdfPoint,
        },
        origin,
        usedByRun: false,
      });
    });
  };

  // Strongest position first: a drawn marker beats the run's board table, which beats label text.
  addUnused(boardMarkers, "boardMarker");
  addUnused(viewBoards, "viewBoards");
  addUnused(boardText, "boardText");
  return candidates;
};
